/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { List, ShareLink, ShareLinkName } from "./data-contracts";

/**
 * No description
 * @tags site-share-links
 * @name ListSiteShareLinks
 * @summary List all share links
 * @request GET:/orgs/{organizationId}/sites/{siteId}/share-links
 * @secure
 */

// @ts-ignore
export const listSiteShareLinks: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ShareLink[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/share-links",
  method: "get",
  streaming: false,
  tags: ["site-share-links"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-share-links
 * @name CreateSiteShareLink
 * @summary Create a share link
 * @request POST:/orgs/{organizationId}/sites/{siteId}/share-links
 * @secure
 */

// @ts-ignore
export const createSiteShareLink: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Name of the share link */
    name: ShareLinkName;
  };
  RequestHeaders: {};
  ResponseBody: ShareLink;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/share-links",
  method: "post",
  streaming: false,
  tags: ["site-share-links"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-share-links
 * @name UpdateSiteShareLinkById
 * @summary Update a share link
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}
 * @secure
 */

// @ts-ignore
export const updateSiteShareLinkById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the share link */
    shareLinkId: string;
  };
  RequestQuery: {};
  RequestBody: {
    active?: boolean;
    /** Name of the share link */
    name?: ShareLinkName;
  };
  RequestHeaders: {};
  ResponseBody: ShareLink;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}",
  method: "patch",
  streaming: false,
  tags: ["site-share-links"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-share-links
 * @name DeleteSiteShareLinkById
 * @summary Deletes a share link
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}
 * @secure
 */

// @ts-ignore
export const deleteSiteShareLinkById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the share link */
    shareLinkId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}",
  method: "delete",
  streaming: false,
  tags: ["site-share-links"],
  criticalityLevel: "low",
  deprecated: false,
};
